import * as React from 'react';
import { useCallback, useEffect, useState } from 'react';
import Stack from '@mui/material/Stack';
import User from 'benchmarking-domain/user';
import { UserForm } from 'components/admin/users/user-form';
import useApi from 'hooks/use-api';
import { enqueueSnackbar } from 'notistack';
import { paths } from 'paths';
import { useNavigate, useParams } from 'react-router-dom';

const UserFormMemo = React.memo(UserForm);

export default function UserDetails(): React.JSX.Element {
  const { userId } = useParams();
  const navigate = useNavigate();
  const { subscribeUser, saveUser } = useApi();
  const [user, setUser] = useState<User>();

  useEffect(() => {
    if (!userId) {
      navigate(paths.errors.notFound, { replace: true });
      return;
    }

    const unsubscribeUser = subscribeUser(userId, (user) =>
      user ? setUser(user) : navigate(paths.errors.notFound, { replace: true })
    );

    return () => {
      unsubscribeUser();
    };
  }, [navigate, userId, subscribeUser]);

  const submitUserChanges = useCallback(
    async (data: User) => {
      try {
        await saveUser({ ...data, id: userId! });
        enqueueSnackbar('User changed!', { variant: 'success' });
      } catch (error) {
        enqueueSnackbar('User save failed! ' + error, { variant: 'error' });
      }
    },
    [userId, saveUser]
  );

  if (!user) return <>Loading...</>;

  return (
    <Stack spacing={3}>
      <UserFormMemo user={user} disableEmail={true} onSubmit={submitUserChanges} />
    </Stack>
  );
}
